import styled from '@emotion/styled';

export const StyledButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  border-radius: 50%;
  background: #292f36;
`;

export const StyledPlayButton = styled(StyledButton)`
  & > div {
    width: 15px;
    margin-left: 2px;
  }
`;

export const StyledPauseButton = styled(StyledButton)`
  &::before,
  &::after {
    position: absolute;
    width: 6px;
    height: 18px;
    border-radius: 1px;
    background: #ffffff;
    content: '';
  }
  &::before {
    left: 17px;
  }
  &::after {
    left: 27px;
  }
`;

export const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  white-space: nowrap;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
`;
